export default [
  {
    path: '/admin/approval-request-flows',
    name: 'approval-request-flow',
    meta: { requiresAuth: true },
    component: () => import('@/pages/setting/approval-request-flow')
  }
]